/* TODO: t() */
import React, { Component, ComponentProps, ElementRef } from 'react';
import { View, TouchableOpacity, StyleSheet } from 'react-native';

import Icon from './Icon';
import { themeColors } from './Constants';
import TextInputWithError from './TextInputWithError';
import isPasswordStrengthEnough from '../../support/shared/isPasswordStrengthEnough';

type Props = ComponentProps<typeof TextInputWithError> & {
  checkPassword: (password: string) => boolean;
  containerStyle?: StyleSet;
};

type State = {
  isPasswordVisible?: boolean;
};

type TextInputInstance = ElementRef<typeof TextInputWithError>;

class TextInputPassword extends Component<Props, State> {
  static defaultProps = {
    checkPassword: isPasswordStrengthEnough,
  };

  state: State = {
    isPasswordVisible: false,
  };

  _ref = React.createRef<TextInputInstance>();

  render() {
    let {
      errorMessage,
      checkPassword,
      containerStyle,
      ...otherProps
    } = this.props;
    let { isPasswordVisible } = this.state;

    return (
      <View style={[styles.container, containerStyle]}>
        <TextInputWithError
          {...otherProps}
          ref={this._ref}
          autoCorrect={false}
          secureTextEntry={!isPasswordVisible}
          errorMessage={errorMessage}
          checkError={checkPassword}
        />
        <TouchableOpacity
          style={styles.iconContainer}
          onPress={this._onPress}
          accessible={false}
        >
          <Icon
            name={isPasswordVisible ? 'visibility' : 'visibilityOff'}
            size="S"
            color={themeColors.mediumGrey}
          />
        </TouchableOpacity>
      </View>
    );
  }

  _onPress = () => {
    this.setState({ isPasswordVisible: !this.state.isPasswordVisible });
  };

  focus() {
    this._ref.current && this._ref.current.focus();
  }
}

let styles = StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
  },
  iconContainer: {
    right: 6,
    zIndex: 10,
    padding: 6,
    cursor: 'pointer',
    alignItems: 'center',
    position: 'absolute',
  },
});

export default TextInputPassword;
